import { createElement, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { DataGridContext } from './DataGridContextProvider';

import classes from './DataGrid.module.scss';

export default function DataGridCol({ align, children }) {
  const { type = 'body' } = useContext(DataGridContext) || {};

  const colComponent = type === 'header' ? 'th' : 'td';

  const className = classNames(
    classes.dataGrid__col,
    classes[`dataGrid__col--align-${align}`],
    classes[`dataGrid__col--${type}`],
  );

  return createElement(colComponent, { className }, children);
}

DataGridCol.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node,
};
